<template>
<transition :css="false" @enter="enter" @leave="leave">
  <div class="Jeu2">
    <div class="Jeu2__cover Vlazy" v-lazy:background-image="oeuvre.image.sizes.large">
      <transition name="Jeu2__infos">
        <div class="Jeu2__infos">
          <div class="Jeu2__infos-title">{{ oeuvre[oeuvre.titre_original].title }}</div>
          <div class="Jeu2__infos-author">{{ oeuvre.author }}</div>
        </div>
      </transition>
    </div>
    <transition @enter="enter" @leave="leave">
      <div class="Jeu2__left" v-if="slugIsIn(['emotions:1', 'emotions:2'])">
        <Visage
          :key="letter"
          v-for="letter in ['a', 'd', 'b', 'c']"
          :ref="'visage_' + letter"
          :face="letter"
          :words="words[letter]"
        />
      </div>
    </transition>
    <div class="Btn" v-if="use_completed" @click="next" v-html="trans('Global.btn.completed')" />
  </div>
</transition>
</template>

<script>
import Visage from './Visage'

export default {
  name: 'Jeu2',
  components: { Visage },
  data: () => ({
    words: {
      // a: ['#FCABAC', '#E48DBA', '#C86EC9', '#AB4DD9'],
      // b: ['#B0ECFC', '#82B3EC', '#587BDD', '#253CCC'],
      // c: ['#FBA56E', '#DA7C6D', '#B9546C', '#A83F6A'],
      // d: ['#BAF873', '#95E580', '#54C69D', '#19A8B5']
      a: ['#FCABAC', '#E48DBA', '#C86EC9'],
      b: ['#B0ECFC', '#82B3EC', '#587BDD'],
      c: ['#FBA56E', '#DA7C6D', '#B9546C'],
      d: ['#BAF873', '#95E580', '#54C69D']
    },
    choices: [],
    use_completed: false,
  }),
  methods: {
    enter(el, done) {
      TweenMax.from(el, 1, { alpha: 0 })
      TweenMax.staggerFrom(el.querySelectorAll('.Visage__face'), 1, { y: 100, alpha: 0, ease: Expo.easeOut }, .1, done)
    },
    leave(el, done) {
      TweenMax.staggerTo(el.querySelectorAll('.Visage__face'), 1, { y: 100, alpha: 0, ease: Expo.easeOut }, -.1, done)
      TweenMax.to(el, 1, { alpha: 0 })
    },
    useChoice() {
      this.$nextTick(()=>{
        const els = [this.$refs['visage_a'][0].$el, this.$refs['visage_b'][0].$el, this.$refs['visage_c'][0].$el, this.$refs['visage_d'][0].$el]
        TweenMax.staggerFrom(els, 0.5, { alpha:0, y:250, ease: Power2.easeOut, delay: 1 }, .1)
      })
    },
    updateChoices(arg) {
      let erase = -1
      _.forEach(this.choices, (value, key)=> {
        if(arg === value)
          erase = key
      })

      erase >= 0
      ? this.choices.splice(erase, 1)
      : this.choices.push(arg)

      if(this.choices.length > 3) {
        this.use_completed = true
        this.choices.splice(0, 1)
      }

      this.choices.length === 3
      ? this.use_completed = true
      : this.use_completed = false
    },
    dispatch(args) {
      let res = args.ref
      if(args.evt === 'onChoiced') {
        this.updateChoices(args.ref)
        res = this.choices
      }
      _.each(['a', 'b', 'c', 'd'], l => this.$refs['visage_' + l][0][args.evt](res))
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Jeu2
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px

  &__infos
    position absolute
    text-align center
    bottom 100%
    margin-bottom 5px
    width 100%
    &-author
      font-size 14px

  &__left
    position absolute
    left 0px
    top 50%
    transform translateY(-50%)

  &__cover
    width 60vw
    left 20vw
    top 110px
    bottom 150px
    position absolute
    background-size contain
    background-position center center
    background-repeat no-repeat
</style>



// WEBPACK FOOTER //
// src/components/jeu2/Jeu2.vue